export default {
  monthsKeysByIndex: {
    0: 'Январь',
    1: 'Февраль',
    2: 'Март',
    3: 'Апрель',
    4: 'Май',
    5: 'Июнь',
    6: 'Июль',
    7: 'Август',
    8: 'Сентябрь',
    9: 'Октябрь',
    10: 'Ноябрь',
    11: 'Декабрь',
  },
  monthsShortKeysByIndex: {
    0: 'Янв.',
    1: 'Февр.',
    2: 'Март',
    3: 'Апр.',
    4: 'Май',
    5: 'Июнь',
    6: 'Июль',
    7: 'Авг.',
    8: 'Сент.',
    9: 'Окт.',
    10: 'Нояб.',
    11: 'Дек.',
  },
  weekdaysKeysByIndex: {
    0: 'Вс',
    1: 'Пн',
    2: 'Вт',
    3: 'Ср',
    4: 'Чт',
    5: 'Пт',
    6: 'Сб',
  },
  button: {
    ok: 'Выбрать',
    cancel: 'Сбросить',
  },
};
